import React, { useContext } from 'react';
import './spinner.css';
import { Backdrop, CircularProgress, Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectLoading } from '../../redux/loading/loading.actions';
import { ThemeContext } from '../ThemeContext/ThemeContext';

const Spinner = () => {
  const isLoading = useSelector(selectLoading);
  const { theme } = useContext(ThemeContext);


  return (
    <Backdrop
      open={isLoading}
      sx={{ color: theme.palette.background.hover, zIndex: 9999 }}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

export default Spinner;
